import { COLORS } from 'const'

export const containerSectionFooter = {
  px: {
    xs: 5,
    sm: 5,
    md: 15,
    xl: 10,
  },
  paddingTop: {
    xs: 10,
    sm: 10,
    md: 20,
  },
  paddingBottom: 10,
  background: 'linear-gradient(to bottom, #161616 60%, #333333)',
  color: 'white',
}

export const landingButtonPrimary = {
  borderRadius: 10,
  /*   backgroundColor: COLORS.button.second, */
  fontWeight: 'bold',
  boxShadow: 0,
  color: 'white',
  width: {
    xs: '100%',
    sm: '100%',
    md: 'fit-content',
    lg: 'fit-content',
  },
  px: { xs: 0, md: 4, lg: 2 },
  minWidth: 200,
  fontSize: { xs: '.9rem', sm: '.9rem', md: '.8rem', lg: '1rem', xl: '1.2rem' },
  fontFamily: 'Work Sans',
}

export const landingButtonSecondary = {
  borderRadius: 10,
  backgroundColor: '#ECEEF1',
  fontWeight: 'bold',
  color: 'black',
  border: 1,
  borderColor: 'white',
  boxShadow: 0,
  width: {
    xs: '100%',
    sm: '100%',
    md: '270px',
  },
  fontFamily: 'Work Sans',
}

export const container = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
}

export const sectionTitleResponsive = {
  fontFamily: 'Poppins',
  fontWeight: 600,
  textAlign: {
    xs: 'center',
    lg: 'left',
  },
  mb: 2,
}

export const sectionTitleResponsiveH3 = {
  ...sectionTitleResponsive,
  fontSize: 'clamp(1.8rem, 2vw, 3rem)',
}

export const sectionDescriptionResponsive = {
  fontFamily: 'Work Sans',
  fontWeight: 400,
  textAlign: {
    xs: 'center',
    sm: 'center',
    md: 'center',
    lg: 'left',
  },
  lineHeight: 1.7,
  mb: 2,
}

export const sectionTitleCentered = {
  fontFamily: 'Poppins',
  fontWeight: 700,
  textAlign: 'center',
  mb: 3,
}

export const sectionTitleCenteredH2 = {
  ...sectionTitleCentered,
  fontSize: 'clamp(2rem, 5vw, 3.5rem)',
}

export const sectionTitleCenteredH3 = {
  ...sectionTitleCentered,
  fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
  fontWeight: 600,
}

export const sectionDescriptionCentered = {
  fontFamily: 'Work Sans',
  fontWeight: 400,
  textAlign: 'center',
  lineHeight: 1.7,
  fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
  px: { xs: 3, md: 15 },
  mb: 4,
}

export const sectionContainer = {
  px: { xs: 4, md: 15 },
  py: { xs: 8, md: 12 },
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  width: '100%',
}

export const sectionContainerDark = {
  ...sectionContainer,
  background: 'linear-gradient(90deg, #1C1C1C 0%, #000000 100%)',
  color: 'white',
  px: { xs: 4, md: 15, lg: 30 },
}

export const sectionContainerLight = {
  ...sectionContainer,
  backgroundColor: '#E0E3E8',
}

export const sectionContentBox = {
  width: '100%',
  maxWidth: 600,
  textAlign: { xs: 'center', md: 'left' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'center', md: 'flex-start' },
}

export const sectionContentBoxNunaSign = {
  width: '100%',
  maxWidth: '500px',
  minWidth: '300px',
  px: { xs: 0, md: 4, lg: 8, xl: 12 },
  textAlign: { xs: 'center', md: 'left' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'center', md: 'flex-start' },
}

export const sectionImage = {
  borderRadius: 2,
  width: '100%',
  maxWidth: { xs: '100%', md: '50%' },
}

export const sectionImageLarge = {
  width: '100%',
  maxWidth: { xs: 'auto', md: '450px' },
  height: { xs: '300px', md: '450px' },
  objectFit: 'cover',
}

export const orderTextFirst = {
  order: { xs: 2, md: 1 },
}

export const orderImageFirst = {
  order: { xs: 1, md: 2 },
}

export const footerMainContainer = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  flexWrap: 'wrap',
  pb: 7,
  gap: { xs: 3, lg: 1 },
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}

export const footerContentContainer = {
  flex: { xs: '1 1 100%', md: '1 1 350px' },
  minWidth: { xs: 'auto', md: '300px' },
  px: { xs: 0, sm: 0, md: 5, lg: 10 },
  justifyContent: { xs: 'center', md: 'flex-start' },
  alignItems: { xs: 'center', md: 'flex-start' },
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}

export const footerFormContainer = {
  flex: { xs: '1 1 100%', md: '1 1 400px' },
  minWidth: { xs: 'auto', md: '350px' },
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  width: '100%',
}

export const footerImage = {
  width: '100%',
  maxWidth: { xs: 250, lg: 400 },
  height: 'auto',
  marginBottom: { xs: 2, lg: 0 },
  marginTop: { xs: 0, lg: 2 },
  display: 'block',
  mx: { xs: 'auto', md: 'auto', lg: 0 },
  order: { xs: 1, lg: 3 },
}

export const footerTitle = {
  ...sectionTitleResponsiveH3,
  order: { xs: 2, lg: 1 },
}

export const footerDescription = {
  paddingTop: 2,
  px: { xs: 5, sm: 10, md: 0 },
  order: { xs: 3, lg: 2 },
}

export const navbarContainer = {
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  paddingTop: 2,
  paddingBottom: 2,
  borderRadius: 10,
}

export const navbarDesktop = {
  ...navbarContainer,
  display: { xs: 'none', md: 'flex' },
}

export const navbarMobile = {
  ...navbarContainer,
  display: { xs: 'flex', md: 'none' },
  gap: 3,
  justifyContent: 'center',
}

export const navbarMenuItem = {
  fontFamily: 'Poppins',
  fontWeight: 200,
  fontSize: { xs: '.9rem', sm: '.9rem', md: '.8rem', lg: '1rem', xl: '1.1rem' },
  color: COLORS.text.whiteAlt,
}

export const normalTextStyle = {
  fontFamily: 'Poppins',
  fontWeight: 300,
  fontSize: { xs: '1rem', md: '1rem', lg: '1rem' },
}

export const captionTextStyle = {
  fontFamily: 'Poppins',
  fontWeight: 300,
  fontSize: 'clamp(0.8rem, 1vw, 1.3rem)',
}

export const titleTextStyle = {
  fontSize: 'clamp(1.8rem, 2.5vw, 3.5rem)',
  fontFamily: 'Poppins',
}

export const stepsContainer = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'center',
  justifyContent: { xs: 'space-around' },
  gap: { xs: 2, md: 0, lg: 1 },
  mb: 4,
  width: { xs: '100%', xl: '90%' },
  maxWidth: '100%',
  mx: 'auto',
}

export const stepItem = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1,
  textAlign: 'center',
  gap: 2,
  width: '100%',
}

export const stepNumber = {
  borderRadius: '50%',
  width: {
    xs: 'clamp(50px, calc(50px + 5vw), 70px)',
    md: 'clamp(30px,calc(30px +  3vw), 60px)',
    lg: 'clamp(60px, calc(50px + 4vw), 70px)',
  },
  height: {
    xs: 'clamp(50px, calc(50px + 5vw), 70px)',
    md: 'clamp(30px,calc(30px +  3vw), 60px)',
    lg: 'clamp(60px, calc(50px + 4vw), 70px)',
  },
  minWidth: { xs: 60, lg: 80 },
  minHeight: { xs: 60, lg: 80 },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontFamily: 'Poppins',
  color: 'white',
  fontSize: 'clamp(1.8rem, 3vw, 50px)',
  flexShrink: 0,
}

export const stepTitle = {
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: 'clamp(1.2rem, 1.8vw, 1.5rem)',
  mb: 1,
}

export const stepDescription = {
  fontFamily: 'Work Sans',
  fontWeight: 400,
  textAlign: { xs: 'left', md: 'left' },
  maxWidth: { xs: 150, md: 300, lg: 1000 },
  lineHeight: 1.5,
}

export const stepImage = {
  width: '100%',
  maxWidth: { xs: 150, md: 200 },
  height: 'auto',
  mt: 2,
}

export const howWorksContainer = {
  px: { xs: 4, md: 15, xl: 20 },
  py: { xs: 8, md: 12 },
  background: 'linear-gradient(to bottom, #161616 60%, #2e2e2e)',
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
}

export const howWorksContent = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  width: '100%',
}

export const videoContainer = {
  position: 'relative',
  width: '100%',
  maxWidth: { xs: '100%', md: '50%' },
  borderRadius: 4,
  overflow: 'hidden',
}

export const videoPreview = {
  width: '100%',
  height: 'auto',
  display: 'block',
}

export const playButton = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 60,
  height: 60,
  backgroundColor: 'rgba(255,255,255,0.8)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.95)',
    transform: 'translate(-50%, -50%) scale(1.1)',
  },
}

export const playIcon = {
  width: 0,
  height: 0,
  borderTop: '10px solid transparent',
  borderBottom: '10px solid transparent',
  borderLeft: '16px solid #191B1E',
  marginLeft: '4px',
}

export const videoIframe = {
  width: '100%',
  aspectRatio: '16/9',
  border: 'none',
  borderRadius: 4,
}

export const howWorksTextContainer = {
  width: '100%',
  maxWidth: { xs: '100%', md: '35%', xl: '30%' },
  textAlign: { xs: 'center', md: 'left' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'center', md: 'flex-start' },
}

export const plansContainer = {
  backgroundColor: '#eaeaeaff',
  px: { xs: 4, md: 8, lg: 30, xl: 15 },
  py: { xs: 8, md: 8, lg: 20 },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 5,
}

export const plansContent = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 5,
  width: '100%',
}

export const plansTextContainer = {
  maxWidth: '100%',
  width: '100%',
  textAlign: 'center',
}

export const plansTitleWhite = {
  fontWeight: 600,
  fontFamily: 'Poppins',
  color: 'white',
  mb: 2,
}

export const plansDescriptionWhite = {
  fontFamily: 'Work Sans',
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 1.6,
  color: 'white',
}

export const cardsContainer = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
}

export const carouselContainer = {
  display: 'flex',
  gap: 3,
  flexWrap: 'nowrap',
  justifyContent: 'center',
  width: '100%',
  overflow: { xs: 'hidden', '@media (min-width: 1393px)': { overflow: 'visible' } },
  position: 'relative',
}

export const carouselMobile = {
  display: { xs: 'block', '@media (min-width: 1393px)': { display: 'none' } },
  width: '100%',
  position: 'relative',
  userSelect: 'none',
}

export const carouselSlide = {
  display: 'flex',
  justifyContent: 'center',
  px: 2,
}

export const carouselSlideContent = {
  width: '100%',
  maxWidth: 320,
}

export const cardsDesktop = {
  display: { xs: 'none', md: 'flex' },
  gap: 3,
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  width: '100%',
}

export const cardDesktop = {
  flex: '1 1 0',
  minWidth: '250px',
  maxWidth: '320px',
}

export const carouselIndicators = {
  display: { xs: 'flex', '@media (min-width: 1393px)': { display: 'none' } },
  justifyContent: 'center',
  alignItems: 'center',
}

export const indicatorContainer = {
  display: 'flex',
  gap: 1,
}

export const indicator = {
  width: 12,
  height: 12,
  borderRadius: '50%',
  cursor: 'pointer',
}

export const sliderContainer = {
  width: '100vw',
  minHeight: '100vh',
  backgroundSize: 'cover',
  backgroundPosition: { xs: 'right 15% center', sm: 'right 15% center', lg: 'center' },
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'local',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  pt: { xs: 2, md: 3 },
  transition: 'background-position 0.5s ease-out',
}

export const sliderNavbarContainer = {
  width: '100%',
}

export const sliderContentContainer = {
  px: { xs: 4, md: 15, xl: 20 },
  pb: { xs: 5, md: 10, xl: 15 },
  pt: { xs: 2, md: 0 },
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: { xs: 'center', md: 'flex-start' },
  flexGrow: 2,
}

export const sliderTextContainer = {
  maxWidth: { xs: '100%', md: '50%', lg: '50%' },
  color: 'white',
  textAlign: { xs: 'center', md: 'left' },
}

export const sliderMainTitle = {
  fontSize: 'clamp(1.5rem, 3vw, 5rem)',
  fontWeight: 700,
  fontFamily: 'Poppins',
  pt: 0,
}

export const sliderLogoContainer = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: { xs: 'center', md: 'flex-start' },
  gap: 2,
  my: 1,
}

export const sliderLogo = {
  width: 'auto',
  height: { xs: 50, sm: 50, md: 55, lg: 60, xl: 80 },
}

export const sliderBrandTitle = {
  fontSize: { xs: '1.5rem', md: '2.1rem', xl: '2.5rem' },
  fontWeight: 800,
  fontFamily: 'Poppins',
  color: COLORS.text.nuna,
}

export const textStyle = {
  lineHeight: 1.8,
  fontFamily: 'Poppins',
  fontSize: 'clamp(1rem, 1.5vw, 1.5rem)',
}

export const thStyle: React.CSSProperties = {
  background: 'rgba(255, 255, 255, 0.1)',
  padding: '16px',
  textAlign: 'left',
  fontWeight: 700,
  fontSize: 16,
  borderBottom: '1px solid rgba(255,255,255,0.2)',
}

export const tdStyle: React.CSSProperties = {
  padding: '14px',
  textAlign: 'left',
  borderBottom: '1px solid rgba(255,255,255,0.1)',
  fontSize: 14,
}
